/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MyRewardPrizeAwarded } from './MyRewardPrizeAwarded';
import {
    MyRewardPrizeAwardedFromJSON,
    MyRewardPrizeAwardedFromJSONTyped,
    MyRewardPrizeAwardedToJSON,
    MyRewardPrizeAwardedToJSONTyped,
} from './MyRewardPrizeAwarded';

/**
 * 
 * @export
 * @interface MyReward
 */
export interface MyReward {
    /**
     * 
     * @type {string}
     * @memberof MyReward
     */
    leaderboardId?: string;
    /**
     * 
     * @type {string}
     * @memberof MyReward
     */
    leaderboardName?: string;
    /**
     * 
     * @type {number}
     * @memberof MyReward
     */
    periodNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof MyReward
     */
    periodEndAt?: number;
    /**
     * 
     * @type {number}
     * @memberof MyReward
     */
    rank?: number;
    /**
     * 
     * @type {number}
     * @memberof MyReward
     */
    finalValue?: number;
    /**
     * 
     * @type {MyRewardPrizeAwarded}
     * @memberof MyReward
     */
    prizeAwarded?: MyRewardPrizeAwarded;
    /**
     * 
     * @type {number}
     * @memberof MyReward
     */
    awardedAt?: number;
}

/**
 * Check if a given object implements the MyReward interface.
 */
export function instanceOfMyReward(value: object): value is MyReward {
    return true;
}

export function MyRewardFromJSON(json: any): MyReward {
    return MyRewardFromJSONTyped(json, false);
}

export function MyRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyReward {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboardId': json['leaderboardId'] == null ? undefined : json['leaderboardId'],
        'leaderboardName': json['leaderboardName'] == null ? undefined : json['leaderboardName'],
        'periodNumber': json['periodNumber'] == null ? undefined : json['periodNumber'],
        'periodEndAt': json['periodEndAt'] == null ? undefined : json['periodEndAt'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'finalValue': json['finalValue'] == null ? undefined : json['finalValue'],
        'prizeAwarded': json['prizeAwarded'] == null ? undefined : MyRewardPrizeAwardedFromJSON(json['prizeAwarded']),
        'awardedAt': json['awardedAt'] == null ? undefined : json['awardedAt'],
    };
}

export function MyRewardToJSON(json: any): MyReward {
    return MyRewardToJSONTyped(json, false);
}

export function MyRewardToJSONTyped(value?: MyReward | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboardId': value['leaderboardId'],
        'leaderboardName': value['leaderboardName'],
        'periodNumber': value['periodNumber'],
        'periodEndAt': value['periodEndAt'],
        'rank': value['rank'],
        'finalValue': value['finalValue'],
        'prizeAwarded': MyRewardPrizeAwardedToJSON(value['prizeAwarded']),
        'awardedAt': value['awardedAt'],
    };
}

